export default __webpack_public_path__ + "static/media/waiter.af2d644e.svg";